<template>
  <v-app-bar fixed app prominent height="100" v-if="latestError" >
    <alert :error="latestError" @close="removeLatestError" />
  </v-app-bar>
</template>

<script>
import appSettings from "@/_mixins/app-settings-mixin"
import alert from "@/_components/layouts/alert"

export default {
  name: 'RecentAlert',
  mixins : [appSettings],
  components: {alert},
  props : {
    msg : {type:String,default:""},
    autoRemoveDelay : {type:Number, default : 5000}
  },
  data()
  {
    return {
      visible : true,
      moreVisible:false,
    }
  },
  computed : {
    latestError()
    {
      return this.globalErrors.length > 0 ? this.globalErrors[this.globalErrors.length - 1] : null;
    }
  },
  watch : {
    latestError(value)
    {
      // this.autoRemoveDelay ? setTimeout(this.removeLatestError, this.autoRemoveDelay) : false;
    }
  },
  methods : {
    toggleMore()
    {
      this.moreVisible = !this.moreVisible;
    },
    removeLatestError()
    {
      this.globalErrors.splice(0,1);
    }
  }
}
</script>

<style scoped lang="scss">
.error
{
  h1
  {
    font-size:18px;
    font-weight:normal;
  }
  p
  {
    font-size:18px;
    font-weight:normal;
    opacity:.8;
  }
  pre
  {
    font-size:14px;
  }

}
.error-message
{
  zoom:.9;
  font-weight:bold;
}
.error-details
{
  zoom:.9;
  font-weight:normal;
}

</style>
